import React from "react";
import { WHITELABEL_DISPLAY_NAME } from "../../config/config";
const Footer = () => (
    <footer className="ant-pro-global-footer">
        <div className="ant-pro-global-footer-copyright">Copyright {new Date().getFullYear()} { WHITELABEL_DISPLAY_NAME }</div>
    </footer>
);

export default Footer;
